import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_BOT_TEMPLATES: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch agent templates.'),
      403: i18n.t('You are not allowed to fetch agent templates.'),
      404: i18n.t('The agent templates you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the agent templates.'),
      default: i18n.t('An error occurred fetching the agent templates.')
    }
  },
  FETCH_BOT_TEMPLATE: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch agent template.'),
      403: i18n.t('You are not allowed to fetch agent template.'),
      404: i18n.t('The agent template you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the agent template.'),
      default: i18n.t('An error occurred fetching the agent template.')
    }
  }
};
